"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logos = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../../utils");
const Styles = __importStar(require("./styles"));
const Logos = ({ localizedLogo, siteId }) => {
    const isPvl = (0, utils_1.isPrivalia)(siteId);
    return ((0, jsx_runtime_1.jsxs)(Styles.Logos, { isPrivalia: isPvl, children: [(0, jsx_runtime_1.jsx)(Styles.VPLogo, { loading: "lazy", siteId: siteId, withParte: true, isLegacy: !isPvl, alt: "logo" }), !isPvl && localizedLogo && (0, jsx_runtime_1.jsx)(Styles.VPLocalizedLogo, { loading: "lazy", src: localizedLogo, alt: "logo" })] }));
};
exports.Logos = Logos;
exports.default = exports.Logos;
